import * as React from 'react';

import * as styles from './IdenticalOffers.css';
import { IIdenticalOffer } from '../../types/identicalOffers';
import { mapIdenticalOffers } from './utils/mapIdenticalOffers';
import { IdenticalOfferCard } from './components/IdenticalOfferCard';
import { Footer } from './components/Footer';

interface IIdenticalOffersProps {
  items: IIdenticalOffer[];
  showAllUrl: string;
  onClickHideButton(): void;
  onClickShowAllButton(): void;
  onClickCard(index: number): void;
}

/**
 * @description Объявления-дубли текущего объявления
 */
export const IdenticalOffers: React.FC<IIdenticalOffersProps> = ({
  items,
  showAllUrl,
  onClickCard,
  onClickHideButton,
  onClickShowAllButton,
}) => {
  // Показывем максимум 4 дубля
  const slicedItems = items.slice(0, 4);
  const offers = mapIdenticalOffers(slicedItems);

  return (
    <div>
      <div className={styles.cards}>
        {offers.map((offer, index) => (
          <div key={offer.id} className={styles.card}>
            <IdenticalOfferCard {...offer} index={index} onClick={onClickCard} />
          </div>
        ))}
      </div>

      <Footer
        showAllUrl={showAllUrl}
        onClickHideButton={onClickHideButton}
        onClickShowAllButton={onClickShowAllButton}
      />
    </div>
  );
};
